export const ROUTES = {
  LOGIN: '/login',
  HOME: '/home',
  SCHOLARSHIP_APPLICATIONS: '/solicitudes',
  GAMES: {
    all: '/juegos',
    create: '/juegos/crear',
    content: '/juegos/contenido',
    content_update: '/juegos/contenido/editar',
    content_create: '/juegos/contenido/crear',
    update: '/juegos/:slug',
  },
  CREDENTIALS: {
    all: '/becas',
    create: '/becas/crear',
    update: '/becas/:id'
  },
  USERS: {
    all: '/usuarios',
    show: '/usuarios/:id'
  },
  EVENTS: {
    all: '/events',
    update: '/events/:id/edit',
  },
  HOSTS: {
    update: '/hosts/:id',
  },
  OWNERS: {
    all: '/owners',
    create: '/owners/crear',
    show: '/owners/:id'
  },
  QUESTS: {
    all: '/quest',
    create: '/quest/crear',
    batch_complete: '/quest/batch_complete/:id',
    show: '/quest/:id',
  },
  USER_CONTENT: {
    all: '/user-content',
    create: '/user-content/crear',
    show: '/user-content/:id'
  },
  NOTIFICATIONS: {
    all: '/notifications',
    create: '/notifications/create',
  },
  PUSH_NOTIFICATIONS: {
    all: '/push-notifications',
    create: '/push-notifications/create',
    edit: '/push-notifications/:uid/edit',
  },
  SEGMENTS: {
    all: '/segments',
    create: '/segments/create',
    edit: (id: number) => `/segments/${id}/edit`,
    assignDevice: '/segments/assign_device',
  },
  DEVICES: {
    all: '/devices',
  },
  MARKETPLACE: {
    all: '/tienda',
    create: '/tienda/crear',
    update: '/tienda/:id'
  },
  TOURNAMENTS: {
    all: '/tournaments',
    create: '/tournaments/crear',
    update: '/tournaments/:id',
    inscriptions: '/tournaments/:id/inscriptions',
    addInscription: '/tournaments/:id/inscriptions/add',
  },
  TOKENS: {
    all: '/tokens',
    create: '/tokens/crear',
    update: '/tokens/:id',
    whitelist: '/tokens/:tokenId/assignments',
    addWhitelistedUser: '/tokens/:id/whitelist/add',
    addWhitelistedUsers: '/tokens/:id/whitelist/batch',
  },
  RELEVANT_ACTIONS: {
    all: '/relevant_actions',
    create: '/relevant_actions/crear',
    update: '/relevant_actions/:id',
  },
  ALERTS: {
    all: '/alerts',
    create: '/alerts/crear',
    update: '/alerts/:id',
  },
  ARTICLE_CTAS: {
    all: '/article_ctas',
    create: '/article_ctas/crear',
    update: '/article_ctas/:id',
  },
  ARTICLE_POLLS: {
    all: '/article_polls',
    update: '/article_polls/:id',
  },
  USER_PERMISSIONS: {
    all: '/permisos',
  },
  ROLES: {
    all: '/permisos/roles',
    create: '/permisos/roles/crear',
    update: '/permisos/roles/:id',
  },
  ROLES_PERMISSIONS: {
    all: '/permisos/permisos_de_rol',
    create: '/permisos/permisos_de_rol/crear',
    update: '/permisos/permisos_de_rol/:id',
  },
  ROULETTE: {
    all: '/ruleta'
  },
  REACTOR_ECONOMY: {
    all: '/reactor-creditos'
  },
  TOKEN_DROPS: {
    all: '/token-drops',
    create: '/token-drops/crear',
    update: '/token-drops/:id',
  },
  PAYMENTS: {
    all: '/payments',
  },
  SURVEYS: {
    all: '/surveys',
    update: '/surveys/:id',
  },
  STORIES: {
    all: '/stories',
    create: '/stories/crear',
    update: '/stories/:id',
  },
  STORY_CATEGORIES: {
    all: '/story-categories',
    create: '/story-categories/crear',
    update: '/story-categories/:id',
  },
  BLOCKCHAIN_TOKEN_CATALOG: {
    all: '/blockchain-token-catalog',
    create: '/blockchain-token-catalog/crear',
    update: '/blockchain-token-catalog/:id'
  },
  BLOCKCHAIN_TOKEN_NETWORKS: {
    all: '/blockchain-token-networks',
    create: '/blockchain-token-networks/crear',
    update: '/blockchain-token-networks/:id'
  },
  MINI_GAMES: {
    all: '/mini_games',
    create: '/mini_games/crear',
    update: '/mini_games/:id',
    treasure_opportunities: {
      all: '/mini_games/treasure-opportunities',
      create: '/mini_games/treasure-opportunities/crear',
      update: '/mini_games/treasure-opportunities/:id',
    },
  },
  USER_PREFERENCES: {
    all: '/user-preferences',
    update: '/user-preferences/:selectedPreference/:id',
  },
  STREAKS: {
    all: '/streaks',
  },
  CARD_DECKS: {
    all: '/card-decks',
    create: '/card-decks/crear',
    update: '/card-decks/:id',
    servers: {
      all: '/card-decks/:deck_id/servers',
      create: '/card-decks/:deck_id/servers/crear',
      update: '/card-decks/:deck_id/servers/:id',
    },
    traits: {
      all: '/card-decks/:deck_id/traits',
      create: '/card-decks/:deck_id/traits/crear',
      update: '/card-decks/:deck_id/traits/:id',
    },
    variants: {
      all: '/card-decks/:deck_id/traits/:trait_id/variants',
      create: '/card-decks/:deck_id/traits/:trait_id/variants/crear',
      update: '/card-decks/:deck_id/traits/:trait_id/variants/:id',
    },
  },
  PRODUCTS: {
    all: '/products',
    create: '/products/crear',
    update: '/products/:id',
    inventory: '/products/:id/inventario',
    showCoupon: '/products/coupons/:id',
    createCoupon: '/products/coupons/crear',
    createPromoCoupon: '/products/promo_coupons/crear',
    showPromoCoupon: '/products/promo_coupons/:id'
  },
  SEASONS: {
    all: '/seasons',
    create: '/seasons/crear',
    update: '/seasons/:id',
    challenges: {
      all: '/seasons/:id/challenges',
      create: '/seasons/:id/challenges/crear',
      update: '/seasons/:id/challenges/:challenge_id',
    },
    tasks: {
      all: '/seasons/:season_id/challenges/:challenge_id/tasks',
      create: '/seasons/:season_id/challenges/:challenge_id/tasks/crear',
      update: '/seasons/:season_id/challenges/:challenge_id/tasks/:id',
    },
    claw_machine_prizes: {
      all: '/seasons/:id/claw-machine-prizes',
      create: '/seasons/:id/claw-machine-prizes/crear',
      update: '/seasons/:id/claw-machine-prizes/:prize_id',
      claims: '/seasons/:id/claw-machine-prizes/:prize_id/claims',
    },
  },
  CLAW_MACHINE_PRIZES: {
    all: '/claw-machine-prizes',
    create: '/claw-machine-prizes/crear',
    update: '/claw-machine-prizes/:id',
  },
  LEVEL_REWARDS: {
    all: '/level-rewards',
    create: '/level-rewards/crear',
    update: '/level-rewards/:id',
  },
  PURCHASE_REWARD_PROMOTIONS: {
    all: '/purchase-reward-promotions',
    create: '/purchase-reward-promotions/crear',
    update: '/purchase-reward-promotions/:id',
  },
  TRIVIA: {
    all: '/trivia',
    create: '/trivia/crear',
    update: '/trivia/:id',
  },
  AGENT_NEWS: {
    all: '/agent-news',
    update: '/agent-news/:id',
  }
}
